import { Control, useController } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { CountryCode } from "libphonenumber-js/types";
import { FormControl, FormErrorMessage, FormLabel, ThemeColorVariable } from "@caspeco/casper-ui-library";
import { getPhoneNumberCountryCode } from "helpers/phone-helper/phone-helper";
import { validatePhoneNumber } from "helpers/validation-helper/validation-helper";
import CustomPhoneInput from "components/custom-phone-input/CustomPhoneInput";
import { IRegisterUserFormFields } from "./types";

interface IPhoneField {
	control: Control<IRegisterUserFormFields, string>;
}

export function PhoneField({ control }: IPhoneField) {
	const { t } = useTranslation();
	const countryCode = (document.querySelector('select[name="phoneNumberCountry"]') as HTMLSelectElement)
		?.value as undefined | CountryCode;

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: "phoneNumber",
		rules: {
			required: false,
			validate: {
				validPhoneNumber: (v) => validatePhoneNumber(v, countryCode) as string,
			},
		},
	});

	return (
		<FormControl id={field.name} isInvalid={Boolean(error)}>
			<CustomPhoneInput
				id={field.name}
				refCallBack={field.ref}
				isInvalid={Boolean(error)}
				onChange={field.onChange}
				label={<FormLabel color={ThemeColorVariable.OnBackground}>{t("form_phone_number")}</FormLabel>}
				autoComplete="tel"
				name={field.name}
				defaultCountry={getPhoneNumberCountryCode(field.value)}
				value={field.value}
			/>
			<FormErrorMessage>{error?.message}</FormErrorMessage>
		</FormControl>
	);
}
